export const PERMS = {
    READ: 'diet_rates.read',
    UPDATE: 'diet_rates.update',
    DELETE: 'diet_rates.delete',
    CREATE: 'diet_rates.create',
    EXPORT: 'diet_rates.export',
}
